import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  PageTitle,
  Text,
  Grid,
  Button,
  Loader,
  Tabs,
} from "@flexisaf/flexibull2";
import { getUrlParam } from "../../utils/helpers";
import BreadCrumbs from "../../components/breadcrumb";
import Papers from "./tabs/papers";
import { DetailsCard } from "../exam-group";
import Theme from "../../theme";
import ExamEditor from "./modals/examEditor";
import useSingleExamGet from "../../hooks/exams/useSingleExamGet";

const Exam = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [modal, setModal] = useState({
    show: false,
    data: null,
  });
  const [reloadTabs, setReload] = useState(false);
  const tab = getUrlParam("activeTab");
  const { id } = useParams();
  const { exam } = useSingleExamGet({ id });

  const handleReload = () => {
    setReload(true);
    setTimeout(() => {
      setReload(false);
    }, 1000);
  };

  useEffect(() => {
    if (tab) {
      setActiveTab(parseInt(tab));
      handleReload();
    }
  }, [tab]);

  const closeModal = () => {
    setModal({
      show: false,
      data: null,
    });
  };
  return (
    <Box>
      <PageTitle>
        <i className="saf-clipboard-text" />
        <Text bold size={Theme.H3} style={{ padding: "0 10px" }}>
          Exams
        </Text>
      </PageTitle>
      <BreadCrumbs
        links={[{ path: `/exam-groups/${exam?.examGroup?.id}`, text: "Exams" }]}
        last={exam?.name || "Paper name"}
      />
      <Box>
        <Grid default="2fr 2fr 1fr">
          <DetailsCard>
            {" "}
            <Box>
              <Text size="1.2rem">{exam?.name || "Exam name"}</Text>
              <p>{exam?.description || "Exam description"}</p>
            </Box>
          </DetailsCard>
          <Box />
          <Box>
            <Button
              pale
              block
              onClick={() => {
                setModal({
                  show: true,
                  data: exam,
                });
              }}
            >
              Edit Exam Information
            </Button>
          </Box>
        </Grid>
      </Box>
      <Box pad="1rem 0">
        {reloadTabs ? (
          <Box pad="150px 0">
            <Loader color={Theme.PrimaryColor} section />
          </Box>
        ) : (
          <Tabs
            activeTab={activeTab}
            padContent="35px 0 0 0"
            bgColor={Theme.PrimaryFade}
          >
            <Box label="Papers">
              <Papers />
            </Box>
          </Tabs>
        )}
      </Box>
      <ExamEditor
        open={modal.show}
        data={modal.data}
        cbProps={{ refetchPaper: true, refetchPapers: false }}
        closeModal={closeModal}
      />
    </Box>
  );
};

export default Exam;
